<template>
    <el-collapse v-model="activeName" accordion>

        <div v-show="trackInfoList.length <= 0">
            暂无追踪信息
        </div>

        <el-collapse-item v-for="(trackInfo, key) in trackInfoList" :key="key" :name="key">

            <template slot="title">

                <i class="el-icon-date">
                    {{trackInfo.enterdate}}
                </i>
                &#12288;&#12288;&#12288;
                <i class="el-icon-user-solid">
                    {{trackInfo.enterby}}
                </i>
                &#12288;&#12288;&#12288;

                <template v-for="(attach) in trackInfo.attachment">
                    <i :class="attach.filename == '' ? '' : 'el-icon-paperclip'">
                    </i>
                </template>

            </template>

            <div>{{trackInfo.description}}</div>
            <a :href="fullUrlList[key]">{{attachmentNameList[key]}}</a>

        </el-collapse-item>

    </el-collapse>
</template>

<script>
    import CommonApi from "@/api/common";

    export default {
        name: "trackInfoList",

        data() {

            return {
                activeName: '',
                trackInfoList: [],
                attachmentNameList: [],
                fullUrlList: [],
            }

        },

        props: {
            ownerId: {
                type: Number,
            },

            ownerTable: {
                type: String,
            }
        },

        methods: {

            getTrackInfoList(ownerId) {
                this.trackInfoList = [];
                this.attachmentNameList = [];
                this.fullUrlList = [];
                CommonApi.getTrackInfoList(ownerId, this.ownerTable).then(res => {
                    if (res.data.code == 200) {
                        this.trackInfoList = res.data.data;
                        this.activeName = this.trackInfoList.length - 1;

                        let fullUrl = '';
                        for (let i = 0; i < this.trackInfoList.length; i++) {
                            let trackInfo = this.trackInfoList[i];
                            if (trackInfo.attachment.length != 0) {
                                let attachmentInfoObj = JSON.parse(trackInfo.attachment[0]);
                                this.attachmentNameList.push(attachmentInfoObj.description);
                                fullUrl = `${process.env.VUE_APP_ATTACHMENT_SERVER}/${attachmentInfoObj.URL}&appId=WEB&token=${localStorage.getItem('token')}`
                                this.fullUrlList.push(fullUrl);
                            } else {
                                this.attachmentNameList.push(null);
                                this.fullUrlList.push(null);
                            }
                        }
                    }
                });
            }

        },

        watch: {
            ownerId: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal) {
                        this.getTrackInfoList(newVal);
                    }
                }
            }
        }


    }
</script>

<style scoped>

</style>